import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pagina-prova',
  templateUrl: './pagina-prova.component.html',
  styleUrls: ['./pagina-prova.component.css']
})
export class PaginaProvaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
